import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Select, Store } from '@ngxs/store';
import { PatientEntity, NetworkMember, Time, CommonService, Config, ReminderStateModel, Reminder, GetReminderForUsername, DeleteReminder } from 'huddyapi';

import moment_ from 'moment';
import { Observable, timer } from 'rxjs';
import { EditReminderDialog } from '../../components/edit-reminder-dialog/edit-reminder-dialog.component';



const moment = moment_;

@Component({
  selector: 'reminders',
  templateUrl: './reminders.component.html',
  styleUrls: ['./reminders.component.scss']
})
export class RemindersComponent implements OnInit {

  @Input() patient : PatientEntity;

  @Select(state => state.reminderState) reminderState$: Observable<ReminderStateModel>;

  reminders : Reminder[];

  constructor(
    private store : Store,
    private config: Config,
    private commonService : CommonService,
    public dialog: MatDialog,
    public matIconRegistry : MatIconRegistry,
    private domSanitizer : DomSanitizer
  ) {


  }

  ngOnInit(): void {
   
    this.reminderState$.subscribe((model: ReminderStateModel) => {
      if (model && model.allUserReminders)
        this.reminders = model.allUserReminders;
    });
    this.store.dispatch(new GetReminderForUsername(this.patient.username));
  }

  getColorFromName(name : string, fromPatient? :boolean) : string {
    let ret : string = '#DAC7FD';
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }

 getInitial(name : string) {
  let ret : string = 'R';
  if (name) {
    ret = name.substring(0,1)
  }
  return ret;
 }

 getReminderTitle(title : string) {
  let ret = 'Reminder for ' + this.patient.firstName;
  if (title) {
    ret = title;
  }
  return ret;
 }

  epochDayToDate(epochDay: number) : string {
    return epochDay && epochDay > 0 ?   Time.fromEpochDay(epochDay).getDateDisplay() : '';
  }


  getLetters(name: string): string {
    name = name.trim();
    return name.substring(0, 1);
  }


  onDelete(reminder : Reminder) {
    this.store.dispatch(new DeleteReminder(reminder.id)).subscribe(t => {
      timer(3000).subscribe(t => this.store.dispatch(new GetReminderForUsername(this.patient.username)));
    });
  }
  

  getPatientName() : string {
    let ret : string = this.patient.firstName + ' ' + this.patient.lastName;
    if (!ret || ret.indexOf("null ") > -1) {
      ret = this.patient.username;
    }
    return ret;
  }

 
  editReminder(reminder : Reminder) {

    let data = {
      id : reminder ? reminder.id : undefined,
      username : this.patient.username,
      endDate : reminder ? reminder.endDate : undefined,
      atDays :  reminder ? reminder.atDays : undefined,
      atTimes : reminder ? reminder.atTimes : undefined,
      patientId : this.patient.id,
      frequency : reminder ? reminder.frequency : 'Daily',
      title : reminder ? this.getReminderTitle(reminder.title) : this.getReminderTitle(null),
      text : reminder ? reminder.text : '',
      timezone: reminder ? reminder.timezone : Intl.DateTimeFormat().resolvedOptions().timeZone,
      tag : 'SCHEDULED'
    }
      
    this.dialog.open(EditReminderDialog, {
      width: '700px',
      height: '500px',
      data: data
    });


  }

}